module.exports = __webpack_public_path__ + "static/media/file-download-icon.8de6fe07.png";